import {baseApiInstanceWithRefresh} from "./baseApiInstance.js";
import {SLIDE_URL} from "./urls.js";

export const getSlideById = async (slideId) => {
    try {
        const response = await baseApiInstanceWithRefresh.get(`${SLIDE_URL}${slideId}/`);
        return response.data;
    } catch (error) {
        console.error('Ошибка при получении данных слайда:', error);
        throw error;
    }
};